import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

// 桁追加ボタン
@Component({
  selector: 'pivot-add-button',
  templateUrl: './add-button.component.html',
  styleUrls: ['./add-button.component.scss']
})
export class AddButtonComponent implements OnInit {

  @Input() disabled: boolean = false;
  @Input() width: number = 0;
  @Input() height: number = 0;
  @Output() onClick = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  handleClick(event: any) {
    if(this.disabled) return;
    this.onClick.emit(event);
  }

  getButtonStyle() {
    const style: any = {};

    if (this.width) {
      style.width = `${this.width}px`;
    }

    if (this.height) {
      style.height = `${this.height}px`;
    }

    return style;
  }
}
